export const ORACLE_PO_STATUS_FILTER_VALUES = [
  "NON_CONCERNED",
  "NOT_SENT",
  "SENDING",
  "ERROR",
  "SYNCHRONIZED",
  "INCOMPLETE",
  "OPEN",
  "CLOSED",
  "FINALLY_CLOSED",
  "CANCELED",
  "PENDING_APPROVAL",
  "IN_PROCESS",
];
